import React from "react";
import PropTypes from "prop-types";

export default class Icon extends React.Component {
  render() {
    const fileURL = require(`./assets/${this.props.type}${
      this.props.checked ? "_colored" : ""
    }.png`);

    return <img src={fileURL} alt={this.props.type} width={30} />;
  }
}

Icon.propTypes = {
  type: PropTypes.string.isRequired,
  checked: PropTypes.bool
};
